/* Built In Imports */

/* Internal Imports */
/* Components */
import config from '@config';
import { tryGetPreviewData } from 'utils';

/* Services */
import { getLocale } from '@components/Utility/Shared/SharedService';
import { filterBuildUrls } from 'services/commonService';
import { IsoBackendHttpService } from 'utils/IsoBackendHttpService';
import { getLatestBuild } from './commonService';

const isCache = false;
const API_PREFIX = '/content/fetchcsr';

export const fetchSadhguruPageData = async (region, lang, previewData) => {
  if (previewData?.preview) {
    return await tryGetPreviewData(previewData, getLocale(region, lang, 'iso'));
  } else {
    const pageData = await new IsoBackendHttpService().get(
      `${API_PREFIX}/content`,
      !isCache,
      {
        params: {
          format: 'json',
          slug: 'sadhguru',
          sitesection: 'sadhguru',
          // region,
          lang,
        },
      }
    );
    return pageData;
  }
};

export const fetchSadhguruMMMPage = async (region, lang, mmm, previewData) => {
  if (previewData?.preview) {
    return await tryGetPreviewData(previewData, getLocale(region, lang, 'iso'));
  }
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        slug: `sadhguru/${mmm}`,
        sitesection: 'sadhguru',
        // region,
        lang,
      },
    }
  );
  return pageData;
};

export const fetchSadhguruMMMArticlePage = async (
  region,
  lang,
  mmm,
  mmm_article,
  previewData
) => {
  if (previewData?.preview) {
    return await tryGetPreviewData(previewData, getLocale(region, lang, 'iso'));
  }
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        slug: `sadhguru/${mmm}/${mmm_article}`,
        sitesection: 'sadhguru',
        // region,
        lang,
      },
    }
  );
  return pageData;
};

export const fetchSadhguruMMMPosts = async (
  mmmSection,
  start = 0,
  contentType = '',
  limit = 8,
  region,
  language,
  previewData
) => {
  if (previewData?.preview) {
    return await tryGetPreviewData(
      previewData,
      getLocale(region, language, 'iso')
    );
  }
  const pageData = await new IsoBackendHttpService().get(
    `${API_PREFIX}/content`,
    !isCache,
    {
      params: {
        format: 'json',
        sitesection: 'sadhguru',
        section: mmmSection,
        start,
        limit,
        contentType,
        // region,
        lang: language,
      },
    }
  );
  return pageData;
};

export const getSadhguruLandingPaths = async (level, url, notMatchText) => {
  const data = config.BUILD_URLS.SADHGURU.enabled
    ? config.BUILD_URLS.SADHGURU
    : await getLatestBuild(
        process.env.NEXT_PUBLIC_BUILD_ID ||
          process.env.env_var_sadhguru_build_id ||
          process.env.env_var_build_id
      );
  const urlArr = filterBuildUrls('sadhguru', level, url, notMatchText, data);
  return urlArr ? urlArr : [];
};
